export const isMobileWebview = (): boolean => {
  return !!(window.flutter_inappwebview || window.webkit?.messageHandlers?.iosHandler || window.androidHandler);
};
